/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TimeSeriesFilterDto { 
    sensorId: string;
    startTime: string;
    endTime: string;
    aggregationInterval?: TimeSeriesFilterDto.AggregationIntervalEnum;
    source?: string;
    includeFlags?: boolean;
}
export namespace TimeSeriesFilterDto {
    export type AggregationIntervalEnum = 'Second' | 'Minute' | 'Hour' | 'Day' | 'Week' | 'Month' | 'Quarter' | 'Year';
    export const AggregationIntervalEnum = {
        Second: 'Second' as AggregationIntervalEnum,
        Minute: 'Minute' as AggregationIntervalEnum,
        Hour: 'Hour' as AggregationIntervalEnum,
        Day: 'Day' as AggregationIntervalEnum,
        Week: 'Week' as AggregationIntervalEnum,
        Month: 'Month' as AggregationIntervalEnum,
        Quarter: 'Quarter' as AggregationIntervalEnum,
        Year: 'Year' as AggregationIntervalEnum
    };
}


